import { openBlock as s, createElementBlock as r, createVNode as o, unref as c, normalizeClass as n, createElementVNode as t, toDisplayString as a } from "vue";
/* empty css                */
import d from "../../_virtual/_plugin-vue_export-helper.js";
import i from "../../atoms/icon/icon.vue.js";
const l = { class: "ds-card-stats ds-display-flex ds-align-items-center" }, m = { class: "ds-margin-left-24" }, y = {
  class: "ds-card-stats__text ds-color-grey-1900 ds-text-small",
  "data-j-eyebrow": ""
}, _ = {
  class: "ds-card-stats__text ds-heading",
  "data-j-title": ""
}, g = "DsCardStats", b = /* @__PURE__ */ Object.assign({
  name: g
}, {
  __name: "card-stats",
  props: {
    /**
     * Card Stats Icon
     * @property {string} name - icon name
     * @property {string} category - icon category
     */
    icon: {
      type: Object,
      required: !0
    },
    /**
     * Card Stats Label
     */
    eyebrow: {
      type: String,
      default: ""
    },
    /**
     * Card Stats text
     */
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (f, u) => (s(), r("div", l, [
      o(c(i), {
        class: n(["ds-card-stats__icon ds-color-green", { "ds-margin-bottom-3": e.eyebrow }]),
        category: e.icon.category,
        name: e.icon.name,
        "aria-label": e.eyebrow
      }, null, 8, ["class", "category", "name", "aria-label"]),
      t("div", m, [
        t("p", y, a(e.eyebrow), 1),
        t("p", _, a(e.title), 1)
      ])
    ]));
  }
}), S = /* @__PURE__ */ d(b, [["__scopeId", "data-v-0998efb8"]]);
export {
  S as default
};
